module.exports = __webpack_public_path__ + "static/16-b76da778ce64e65dc43d86e2d4800fb7.jpg";